/**
 * Copyright (c) 2017 CRF Box Oy. All Rights Reserved. Company Confidential.
 */

import React from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { Layout } from '../components/layout';
import AuthService from '../service/authService';
import store from '../store/store';
import { loginSuccess, loginError, setClientConfiguration, logOutAndCleanSession } from '../actions/actions';
import {
  StudiesPage,
  ParticipantsPageContainer,
  PeopleDetailsPage,
  PeoplePageContainer,
  ParticipantDetailsContainer,
  OrganizationDetailsContainer
} from './pages';

import forbidenPage from '../components/layout/forbidden/forbidden.container';
import {
  forbiden,
  home,
  participant,
  participants,
  userManagement,
  userManagementPeople,
  userManagementStudy,
  userManagementStudyParticipant,
  userManagementOrgStudy,
  userManagementOrgStudyParticipant,
  peopleDetails_peopleFlow,
  organization_details,
  peopleDetails_studyFlow
} from '../constants/localUrls';
import { HTTP_STATUS_MESSAGES } from '../const.js';
import { clearStorage, handleRefreshCookie, setupGlobalLogoutManager } from '../utils/cookieHelpers';
import { getUserInfoFromAccessToken } from '../utils/cookies';

const hasAccessToClient = function (userData) {
  return userData && userData.data && userData.data.user && !userData.data.user.isParticipant;
};

const signOut = (SSOLogoutUrl) => {
  store.dispatch(logOutAndCleanSession(SSOLogoutUrl));
};

const authenticate = () => {
  AuthService.auth()
    .then((userData) => {
      const email = userData.data ? (userData.data.user ? userData.data.user.email : null) : null;
      setupGlobalLogoutManager(email, signOut);

      if (hasAccessToClient(userData)) {
        store.dispatch(loginSuccess(userData.data));
      } else {
        store.dispatch(loginError({ error: HTTP_STATUS_MESSAGES['401'] }));
      }
    })
    .catch((err) => {
      store.dispatch(loginError({ error: err }));
    })
    .finally(() => {
      // In all cases, try to get clientconfiguration so we can show
      // user initials in header.
      AuthService.getClientConfiguration()
        .then((response) => {
          store.dispatch(setClientConfiguration(response));
          const { email, exp } = getUserInfoFromAccessToken(response.data.accessToken);
          if (exp) {
            clearStorage();
            handleRefreshCookie(exp, email);
          } else {
            clearStorage();
          }
        })
        .catch((error) => {
          store.dispatch(loginError(error));
        });
    });
};

export default (
  <Router componentWillMount={authenticate()}>
    <Switch>
      <Route exact path={forbiden()} component={forbidenPage} />
      <Layout>
        <Switch>
          <Route exact path={home()} component={StudiesPage} />
          <Route exact path={participants(':studyGid')} component={ParticipantsPageContainer} />
          <Route exact path={participant(':participantJourneyGid')} component={ParticipantDetailsContainer} />
          <Route exact path={userManagement()} component={PeoplePageContainer} />
          <Route exact path={userManagementPeople(':userId')} component={PeopleDetailsPage} />
          <Route exact path={userManagementStudy(':studyGid')} component={ParticipantsPageContainer} />
          <Route
            exact
            path={userManagementOrgStudy(':organizationId', ':organizationName', ':studyGid')}
            component={ParticipantsPageContainer}
          />
          <Route
            exact
            path={userManagementOrgStudyParticipant(':organizationId', ':organizationName', ':participantJourneyGid')}
            component={ParticipantDetailsContainer}
          />
          <Route
            exact
            path={userManagementStudyParticipant(':participantJourneyGid')}
            component={ParticipantDetailsContainer}
          />
          <Route
            exact
            path={peopleDetails_peopleFlow(':userId', ':organizationId', ':organizationName')}
            component={PeopleDetailsPage}
          />
          <Route
            exact
            path={organization_details(':organizationId', ':organizationName')}
            component={OrganizationDetailsContainer}
          />
          <Route exact path={peopleDetails_studyFlow(':studyGid', ':userId')} component={PeopleDetailsPage} />
          <Route path="/*" component={StudiesPage} /> {/* default route in case none of the above match */}
        </Switch>
      </Layout>
    </Switch>
  </Router>
);
